module.exports = __webpack_public_path__ + "static/scale-model-of-museum-of-natural-and-cultural-history-in-eugene-oregon-48ba7e52eb5f12fa7c4e997f89d5ecc7.png";